export default __webpack_public_path__ + "static/media/A5_LANDSCAPE_ORI.dd61a752.png";